export * from 'server/models/Role';


// WEBPACK FOOTER //
// ./data/models/Role.ts